// Core imports
import React from 'react';
import PropTypes from 'prop-types';

const PublicRoute = ({
  component: Component,
  layout: Layout,
  ...rest
}) => {
  return (
    <Layout {...rest}><Component /></Layout>
  );
};

PublicRoute.propTypes = {
  component: PropTypes.func,
  layout: PropTypes.func.isRequired
};

export default PublicRoute;
